import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredFavouriteFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M8.94445 14.6197C8.41265 15.128 7.59396 15.128 7.06217 14.6123L6.9852 14.5387C3.31161 11.0395 0.911534 8.7484 1.0025 5.89011C1.04448 4.63777 1.65325 3.43699 2.63987 2.72979C4.48716 1.40378 6.76828 2.02258 7.99981 3.54013C9.23133 2.02258 11.5125 1.39641 13.3597 2.72979C14.3464 3.43699 14.9551 4.63777 14.9971 5.89011C15.0951 8.7484 12.688 11.0395 9.01442 14.5534L8.94445 14.6197Z"
      fill="url(#paint0_linear_1461_1010)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1461_1010"
        x1={8}
        y1={2}
        x2={8}
        y2={15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E92353" />
        <stop offset={1} stopColor="#8A0223" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredFavouriteFilled)
const IconSvgColouredFavouriteFilled = createIcon(
  ForwardRef,
  'SvgColouredFavouriteFilled',
)
export default IconSvgColouredFavouriteFilled
